export enum SyntaxKind {
  Or,
  And,
  LeftParen,
  RightParen,
  Integer,
  Float,
  String,
  Identifier,
  Equals,
  NotEquals,
  LessThan,
  LessOrEqualThan,
  MoreThan,
  MoreOrEqualThan,
  Contains,
  NotContains,
  Error,
  WhiteSpace,
  Colon,
  Comma,
  Not,
  Is,
  IsNot,
  Empty,
  IsEmpty,
  IsNotEmpty,
  EOF,
  Search,
}
